import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
    form: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        maxWidth: 550,
    },
    input: {
        width: '100%',
        marginBottom: 30,
    },
    buttonWrapper: {
        marginBottom: 100,
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
    },
    title: {
        marginBottom: 30,
    },
    button: {
        padding: '15px 30px',
    },
}));
